import { Source } from '../types/census';

export type Grade = 'A' | 'B' | 'C';

export const GRADE_FOR_KIND: Record<Source['kind'], Grade> = {
  api: 'A',
  official: 'A',
  registry: 'A',
  publication: 'B',
  estimate: 'C',
};

export const GRADE_INFO: Record<Grade, { label: string; detail: string; className: string }> = {
  A: { label: 'Official measurement / API', detail: 'Read directly from an official statistic, filing, vendor spec or live API.', className: 'text-live' },
  B: { label: 'Reputable aggregation', detail: 'Compiled by a publication or analyst from other sources.', className: 'text-human' },
  C: { label: 'Fermi estimate', detail: 'Our own labeled assumption with an explicit range.', className: 'text-machine' },
};
